export default __webpack_public_path__ + "static/media/Skull Clasp of Bloody Carnage.a76a4879.jpg";